export default __webpack_public_path__ + "static/media/assessment.6d85b831.svg";